import { render, staticRenderFns } from "./CourseSoldOut.vue?vue&type=template&id=18a48660&scoped=true&"
import script from "./CourseSoldOut.vue?vue&type=script&lang=js&"
export * from "./CourseSoldOut.vue?vue&type=script&lang=js&"
import style0 from "./CourseSoldOut.vue?vue&type=style&index=0&id=18a48660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a48660",
  null
  
)

export default component.exports